import React from "react";

export const LongTextCell = ({ dataItem, field, tdProps }) => {
    const value = dataItem?.[field];

    const cellStyle = {
        textOverflow: 'clip',
        whiteSpace: 'break-spaces',
        wordBreak: 'break-word',
        ...tdProps?.style
    };

    const cellProps = {
        ...tdProps,
        style: cellStyle
    };

    return (
        <td {...cellProps}>
            {value}
        </td>
    );
};